import React, { useState } from 'react'
import { DataContext } from '../../helper/HelperOne'
import NavBar from '../nav_bar/Navbar'
import LeadProductsCreate from './LeadProductsCreate'

function LeadProducts() {
    const [searchUi, setSearchUi] = useState(true)
    const [searchData, setSearchData] = useState(null)

    return (

        <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<LeadProductsCreate/>}
                menuId={13}
            />
        </DataContext.Provider>
    )
}

export default LeadProducts